import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { Box, Carousel, CarouselContent, CarouselNext, CarouselPrevious, CarouselSlot, Stack, TextAlpha, } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { SlideCropped } from '../../constants/SliderConstants';
import { getPictureSrcset } from '../../util/ImageUtil';
import { getSlideSizeWithGap } from '../carousel/Carousel';
const IMAGE_HEIGHT = 200;
const SLIDES_PER_VIEW_MOBILE = 1;
const SLIDES_PER_VIEW_TABLET = 2;
const SLIDES_PER_VIEW_DESKTOP_MIN = 3;
const DistinctiveProductDetails = ({ distinctiveProductDetails = [] }) => {
    const { imageCdnPrefix } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.product);
    if (!distinctiveProductDetails.length)
        return null;
    const carouselGap = 4;
    const slidesPerViewMobile = distinctiveProductDetails.length > SLIDES_PER_VIEW_MOBILE
        ? getSlideSizeWithGap(SLIDES_PER_VIEW_MOBILE + SlideCropped.MEDIUM, carouselGap)
        : getSlideSizeWithGap(SLIDES_PER_VIEW_MOBILE, carouselGap);
    const slidesPerViewTablet = distinctiveProductDetails.length > SLIDES_PER_VIEW_TABLET
        ? getSlideSizeWithGap(SLIDES_PER_VIEW_TABLET + SlideCropped.MEDIUM, carouselGap)
        : getSlideSizeWithGap(SLIDES_PER_VIEW_TABLET, carouselGap);
    const slidesPerViewDesktop = distinctiveProductDetails.length > SLIDES_PER_VIEW_DESKTOP_MIN
        ? getSlideSizeWithGap(4, carouselGap)
        : getSlideSizeWithGap(SLIDES_PER_VIEW_DESKTOP_MIN, carouselGap);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { paddingBlockEnd: "4", children: _jsx(TextAlpha, { as: "h2", variant: "subheadingXL", testId: "distinctive-product-details-title", children: t('product.distinctive.details.title') }) }), _jsx(Carousel, { slideSize: {
                    xs: slidesPerViewMobile,
                    sm: slidesPerViewTablet,
                    lg: slidesPerViewDesktop,
                }, rows: 1, testId: "distinctive-product-details", children: _jsxs(Stack, { direction: "col", gap: "4", children: [_jsx(CarouselContent, { children: distinctiveProductDetails.map((details, index) => {
                                var _a;
                                return (_jsx(CarouselSlot, { children: _jsx("div", { style: { height: 'auto' }, children: _jsxs(Card, { fullWidth: true, children: [_jsx(Card.Media, { height: IMAGE_HEIGHT, src: (_a = details.asset) === null || _a === void 0 ? void 0 : _a.imagePath, srcset: getPictureSrcset(details.asset, imageCdnPrefix), alt: details.heading }), _jsx(Card.Header, { title: details.heading }), _jsx(Card.Body, { children: _jsx(TextAlpha, { children: details.description }) })] }) }, details.id) }, `gift_voucher_main_${index}`));
                            }) }), _jsxs(Stack, { gap: "1", justify: "end", children: [_jsx(CarouselPrevious, {}), _jsx(CarouselNext, {})] })] }) })] }));
};
export default DistinctiveProductDetails;
